"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_internal_contract_js_1 = require("@tableau/api-internal-contract-js");
const api_shared_js_1 = require("@tableau/api-shared-js");
class AuthServiceImpl extends api_shared_js_1.ServiceImplBase {
    get serviceName() {
        return "authentication" /* Authentication */;
    }
    setAuthToken(authToken) {
        const parameters = {
            authToken,
        };
        return this.execute(api_internal_contract_js_1.VerbId.Authenticate, parameters).then((response) => {
            return;
        });
    }
}
exports.AuthServiceImpl = AuthServiceImpl;
//# sourceMappingURL=AuthServiceImpl.js.map